module.exports = __webpack_public_path__ + "img/caiwuyun_bg.8a754732.png";